// GLSL for transport routes (render/routes/TransportRouteLayer.ts): additive dashed lines on the emissive layer.

/**
 * A route line: per-vertex owner colour and route distance (radians from the route's start, so dashes stay put on
 * the globe while the travelled part is trimmed away). The dash pattern scrolls toward larger distances, i.e. toward
 * the destination, as uDashPhase grows.
 */
export const ROUTE_VERTEX = /* glsl */ `
attribute vec3 aColor;
attribute float aDistance;

varying vec3 vColor;
varying float vDistance;

void main() {
  vColor = aColor;
  vDistance = aDistance;
  gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
}
`

export const ROUTE_FRAGMENT = /* glsl */ `
uniform float uIntensity;
uniform float uDashPeriod;
uniform float uDashPhase;
uniform float uDashDuty;

varying vec3 vColor;
varying float vDistance;

void main() {
  if (fract(vDistance / uDashPeriod - uDashPhase) > uDashDuty) discard;
  gl_FragColor = vec4(vColor * uIntensity, 1.0);
}
`
